export default "__VITE_ASSET__CmgGDj2z__"